var entities = [
    {
        label: Loc.g('Email'),
        value: 'email',
        checked: true,
    },
    {
        label: Loc.g('Appel'),
        value: 'phonecall',
        checked: true,
        plugin: 'phonecall',
    },
    {
        label: Loc.g('Client'),
        value: 'client',
        checked: true,
    },
    {
        label: Loc.g('Avoir'),
        value: 'creditnote',
        checked: false,
        plugin: 'invoicing',
    },
    {
        label: Loc.g('Facture'),
        value: 'invoice',
        checked: false,
        plugin: 'invoicing',
    },
    {
        label: Loc.g('Facture proforma'),
        value: 'proforma',
        checked: false,
        plugin: 'invoicing',
    },
    {
        label: Loc.g('Fournisseur'),
        value: 'supplier',
        checked: false,
    },
    {
        label: Loc.g('Campagne marketing'),
        value: 'campaign',
        checked: false,
        plugin: 'massmailing',
    },
    {
        label: Loc.g('Opportunité'),
        value: 'opportunity',
        checked: false,
        plugin: 'prospection',
    },
    {
        label: Loc.g('Contact'),
        value: 'people',
        checked: false,
    },
    {
        label: Loc.g('Document redactor'),
        value: 'propdocument',
        checked: false,
        plugin: 'proposal',
    },
    {
        label: Loc.g('Modèle redactor'),
        value: 'proptemplate',
        checked: false,
        plugin: 'proposal',
    },
    {
        label: Loc.g('Ticket'),
        value: 'ticket',
        checked: false,
        plugin: 'support',
    },
    {
        label: Loc.g('Prospect'),
        value: 'prospect',
        checked: false,
    },
    {
        label: Loc.g('Compte email'),
        value: 'nylasAccount',
        checked: false,
    },
    {
        label: Loc.g('Commentaire'),
        value: 'annotation',
        checked: true,
    },
    {
        label: Loc.g('Evènement'),
        value: 'event',
        checked: true,
    },
    {
        label: Loc.g('Timetracking'),
        value: 'timetracking',
        checked: true,
    },
    {
        label: Loc.g('Tâche'),
        value: 'task',
        checked: true,
    },
    {
        label: Loc.g('Contact'),
        value: 'thirdcontact',
        checked: false,
    },
    {
        label: Loc.g('Devis'),
        value: 'estimate',
        checked: false,
    },
    {
        label: Loc.g('Facture'),
        value: 'invoice',
        checked: false,
    },
    {
        label: Loc.g('Avoir'),
        value: 'creditnote',
        checked: false,
    },
    {
        label: Loc.g('Proforma'),
        value: 'proforma',
        checked: false,
    },
    {
        label: Loc.g('Bon de commande'),
        value: 'order',
        checked: false,
    },
    {
        label: Loc.g('Bon de livraison'),
        value: 'delivery',
        checked: false,
    },
    {
        label: Loc.g('Connexion'),
        value: 'staff',
        checked: false,
    },
    {
        label: Loc.g('Compte Email'),
        value: 'nylasAccount',
        checked: false,
    },
    {
        label: Loc.g('Activité personnalisée'),
        value: 'customactivity',
        checked: false,
    },
    {
        label: Loc.g('Tracking'),
        value: 'snippettracking',
        checked: true,
    },
    {
        label: Loc.g('Marketing'),
        value: 'marketing',
        checked: true,
    },
];

export { entities };
